<div mat-dialog-title class="request-certificate-dialog-title">
	<span translate>guarantee.certificate.request</span>

	<button type="button" mat-icon-button class="close-button" disableRipple (click)="evtCancel()">
		<mat-icon svgIcon="md:close"></mat-icon>
	</button>
</div>

<div mat-dialog-content class="request-certificate-dialog-content">
	<p>
		<span class="request-certificate-dialog-message" translate>guarantee.certificate.request.confirmation</span>
		<span class="request-certificate-dialog-guarantee-name">
			<strong>{{ data.guaranteeName }}</strong>?
		</span>
	</p>
</div>

<div mat-dialog-actions class="request-certificate-dialog-actions">
	<button type="button" mat-stroked-button class="request-certificate-dialog-cancel" (click)="evtCancel()">
		<span translate>dashboard.cancel</span>
	</button>
	<button type="button" mat-raised-button class="request-certificate-dialog-confirm" (click)="evtConfirm()" copoFocusMe>
		<span translate>navig.confirm</span>
	</button>
</div>
